import React from 'react';
import styled from 'styled-components';
import { FlexBox } from '../../../styles/tabContainers';

interface IInfo {
  children: React.ReactNode;
}

export const Info = styled(({ children, ...props }: IInfo) => (
  <FlexBox alignItems='center' {...props}>
    {children}
  </FlexBox>
))`
  font-size: 2rem;
  font-weight: 400;
  float: right;
  span {
    display: inline-block;
    margin-left: 0.8rem;
  }
`;
